import time from "src/utils/time";
import { BodyText2 } from "src/atoms/typography";

export default function CurrentTime({ currentTime }) {
  return (
    <BodyText2 color="white" textAlign="center" minWidth="40px">
      {time.duration(currentTime * 1000).format("m:ss")}
    </BodyText2>
  );
}
